import { createFragmentContainer, graphql } from 'react-relay';
import OpenSignContract from './OpenSignContractComponent';

export default createFragmentContainer(OpenSignContract, {
  viewer: graphql`
    fragment OpenSignContractContainer_viewer on User {
      id
    }
  `,
});



// WEBPACK FOOTER //
// ./webpack/components/Share/OpenSignContractContainer.js